import { render } from "./Braedcrumb.vue?vue&type=template&id=4e637e18"
import script from "./Braedcrumb.vue?vue&type=script&lang=js"
export * from "./Braedcrumb.vue?vue&type=script&lang=js"

import "./Braedcrumb.vue?vue&type=style&index=0&id=4e637e18&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__